import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Grid,
	Card,
	CardContent,
	Button,
	Typography,
	Checkbox,
	Chip
} from '@material-ui/core';



//components
import ContentMenu from '../../../mylibrary/components/ContentMenu';
import ContentCard from '../MilestoneDetails/ContentCard';
import ContentDetailsDrawer from '../MilestoneDetails/ContentDetailsDrawer';
import ContentDeleteConfirm from '../../../mylibrary/components/ContentDeleteConfirm';
import ContentShareModal from '../../../mylibrary/components/ContentShareModal';
import UnlockConceptModel from '../UnlockConceptModel';
import ScheduleDialog from '../ScheduleDialog';
import DisplayNameDialog from '../DisplayNameDialog';

//types
import ContentData from '../../../mylibrary/types/ContentData';
import ACL from '../../../acl/components/ACL';
//actions

import courseService from '../../services/courseService';
import contentService from '../../../mylibrary/services/contentService';
import { styles } from '../../styling/component/MilestoneDetails/ContentList'

//@ts-ignore
interface WithContentProps extends WithStyles<typeof styles> {
	classes: any,
	contentList: ContentData[],
	contentActionList: Function,
	userId: string,
	isInPopUp: boolean,
	onContentSelect: Function,
	selectedQuestions: ContentData[],
	cardFlag: string,
	listContent: () => void,
}

interface WithContentStates {
	isDetailDrawerOpen: boolean,
	DetailDrawerContent?: ContentData,
	currentPage: number,
	totalCount: number,
	selectedContents: ContentData[],
	selectedContentsAll: boolean,
	isDeleteDialogOpen: boolean,
	isShareDialogOpen: boolean,
	unlockConceptModal: boolean,
	currentContentId: string,
	isScheduleDialogOpen: boolean,
	isSetDisplayNameDialogOpen: boolean,
}

class WithContent extends Component<WithContentProps, WithContentStates>{
	searchInterval: any;
	constructor(props: WithContentProps) {
		super(props);
		this.state = {
			isDetailDrawerOpen: false,
			currentPage: 1,
			totalCount: 0,
			selectedContents: [],
			selectedContentsAll: false,
			isDeleteDialogOpen: false,
			isShareDialogOpen: false,
			unlockConceptModal: false,
			currentContentId: "",
			isScheduleDialogOpen: false,
			isSetDisplayNameDialogOpen: false,
		};

		this.handleDetailDrawerOpen = this.handleDetailDrawerOpen.bind(this);
		this.handleDetailDrawerClose = this.handleDetailDrawerClose.bind(this);
		this.markAsFavourite = this.markAsFavourite.bind(this);
		this.setContentSelected = this.setContentSelected.bind(this);
		this.isInSelectedContent = this.isInSelectedContent.bind(this);
		this.selectAllContent = this.selectAllContent.bind(this);
		this.moreMenuClicked = this.moreMenuClicked.bind(this);
		this.onDeleteConfirmed = this.onDeleteConfirmed.bind(this);
		this.onShared = this.onShared.bind(this);
		this.unlockConceptModel = this.unlockConceptModel.bind(this);
		this.openConceptModel = this.openConceptModel.bind(this)

		this.handleScheduleDialogOpen = this.handleScheduleDialogOpen.bind(this);
		this.handleScheduleDialogClose = this.handleScheduleDialogClose.bind(this);
		this.handleSetDisplayNameDialogOpen = this.handleSetDisplayNameDialogOpen.bind(this);
		this.handleSetDisplayNameDialogClose = this.handleSetDisplayNameDialogClose.bind(this);
	}


	componentDidMount() {
	}

	componentWillReceiveProps() {
		setTimeout(this.selectedInConent.bind(this), 3000);
	}

	selectedInConent() {
		if (this.props.selectedQuestions && this.props.selectedQuestions.length) {
			let { selectedQuestions } = this.props;
			this.setState({ selectedContents: selectedQuestions })
		}
	}

	handleDetailDrawerOpen = (event: any, content: any) => {
		event.preventDefault();
		let contentId = content._id + content.type;
		courseService.getContentDetails(contentId).then((details: any) => {
			this.setState({
				isDetailDrawerOpen: true,
				DetailDrawerContent: details
			});
		});

	};

	handleDetailDrawerClose = (event: any) => {
		this.setState({
			isDetailDrawerOpen: false,
		});
	};

	markAsFavourite(i: number, isFavourite: number) {
		let id = this.props.contentList[i]._id
		contentService.markAsFavourite(id, isFavourite).then(() => {
			if (isFavourite == 0) {
				this.props.contentList[i].favourites = this.props.contentList[i].favourites.filter(id => id != this.props.userId);
			} else {
				this.props.contentList[i].favourites.push(this.props.userId);
			}

			this.forceUpdate();
		});
	}

	selectAllContent(e: any, checked: boolean) {
		const { contentList } = this.props;
		if (checked) {
			this.setState({ selectedContents: contentList, selectedContentsAll: true });
		} else {
			this.setState({ selectedContents: [], selectedContentsAll: false });
		}
	}

	isInSelectedContent(id: string, content_Id: string = "") {
		const { selectedContents } = this.state;
		if (selectedContents.filter(c => (c._id == id || c.content_Id == content_Id)).length) {
			return true;
		}
		return false;
	}

	setContentSelected(c: ContentData, checked: boolean) {
		let { selectedContents } = this.state;
		if (checked) {
			selectedContents.push(c);
		} else {
			selectedContents = selectedContents.filter(sc => sc._id != c._id);
		}
		this.setState({ selectedContents, selectedContentsAll: false });

		if (this.props.onContentSelect) {
			this.props.onContentSelect(selectedContents, (this.props.cardFlag == "chapter" ? true : false));
		}
	}

	moreMenuClicked(item: string) {
		if (this.state.selectedContents.length == 0) {
			return false;
		}
		//perform on selected content
		if (item == "Delete") {
			this.setState({ isDeleteDialogOpen: true });
		}
		//perform on selected content
		if (item == "Share") {
			this.setState({ isShareDialogOpen: true });
		}
	}

	onDeleteConfirmed(action: boolean) {
		this.setState({ isDeleteDialogOpen: false });

		if (action) {
			setTimeout(() => {
			}, 500)

			this.clearSelectedContent();
		}
	}

	unlockConceptModel() {
		this.setState({
			unlockConceptModal: true
		})
	}

	unlockCloseHandler() {
		this.setState({
			unlockConceptModal: false
		})
	}

	onShared(shared: boolean) {
		this.setState({ isShareDialogOpen: false });
		let t = 300;

		if (this.state.selectedContentsAll) {
			t = t * 20;
		} else {
			t = t * this.state.selectedContents.length;
		}

		if (shared) {
			setTimeout(() => {
			}, t)

			this.clearSelectedContent();
		}
	}

	clearSelectedContent() {
		this.setState({ selectedContentsAll: false, selectedContents: [] })
	}


	openConceptModel(contentId: string) {
		this.setState({
			unlockConceptModal: true,
			currentContentId: contentId
		})
	}

	handleScheduleDialogOpen = (contentId: string) => {
		this.setState({
			isScheduleDialogOpen: true,
			currentContentId: contentId
		})
	}

	handleScheduleDialogClose = () => {
		this.setState({
			isScheduleDialogOpen: false
		})
	}

	handleSetDisplayNameDialogOpen = (contentId: string) => {
		this.setState({
			isSetDisplayNameDialogOpen: true,
			currentContentId: contentId
		})
	}

	handleSetDisplayNameDialogClose = () => {
		this.setState({
			isSetDisplayNameDialogOpen: false
		})
	}


	render() {
		const { isDeleteDialogOpen, isShareDialogOpen, selectedContents, selectedContentsAll,
			isDetailDrawerOpen, DetailDrawerContent,
			currentPage, totalCount, currentContentId } = this.state;
		const { classes, contentList, cardFlag } = this.props;
		let searchTextRegex;
		let assigmentCount = 0;
		let CardList: any = "";
		if (contentList.length > 0) {
			CardList = contentList.map((content, index: number) => {
				if (content.type == "testpapers") { assigmentCount++ }
				return <ContentCard
					key={index}
					index={index}
					content={content}
					cardFlag={cardFlag}
					assigmentCount={assigmentCount}
					setContentSelected={this.setContentSelected}
					openConceptModel={this.openConceptModel}
					isInSelectedContent={this.isInSelectedContent}
					onViewDetailsClick={this.handleDetailDrawerOpen.bind(this)}
					onScheduleClick={this.handleScheduleDialogOpen.bind(this)}
					onSetDisplayNameClick={this.handleSetDisplayNameDialogOpen.bind(this)}
				/>
			});
		}

		return (
			<>
				<Grid container>
					<Grid item xs={12}>
						<Grid container className={classes.paddingLeft}>
							<Grid item xs={12}>
								{

									!_.isEmpty(contentList) &&
									CardList
								}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				<ContentDetailsDrawer
					onDetailDrawerClose={this.handleDetailDrawerClose.bind(this)}
					isDetailsDrawerOpen={isDetailDrawerOpen}
					content={DetailDrawerContent}
				/>
				<UnlockConceptModel
					openUnlockConcept={this.state.unlockConceptModal}
					closeConceptModel={this.unlockCloseHandler.bind(this)}
					contentID={currentContentId}
				/>
				{this.state.isScheduleDialogOpen ? (
					<ScheduleDialog
						isOpen={this.state.isScheduleDialogOpen}
						handleClose={this.handleScheduleDialogClose.bind(this)}
						contentId={currentContentId}
						handleListContent={this.props.listContent}
					/>
				) : null}

				{this.state.isSetDisplayNameDialogOpen ? (
					<DisplayNameDialog
						isOpen={this.state.isSetDisplayNameDialogOpen}
						handleClose={this.handleSetDisplayNameDialogClose.bind(this)}
						selectedContent={_.find(this.props.contentList, ['_id', currentContentId])}
						handleListContent={this.props.listContent}
					/>
				) : null}
			</>
		);
	}
}

const mapStateToProps = (state: any) => ({
}
);

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
	{
	},
	dispatch
);



// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(WithContent));